import { type BoundActions, type HookReturnValue } from 'react-sweet-state';

import usePrevious from '@atlaskit/frontend-utilities/use-previous';

import { useTeamId } from '../../../team-context';
import { type TeamActions } from '../../main';
import { type TeamAppState } from '../../types';

export const useOrCollectData = <State extends { isLoading: boolean; hasLoaded: boolean }>(
	stateSlice: HookReturnValue<State, BoundActions<TeamAppState, TeamActions>>,
): HookReturnValue<State, BoundActions<TeamAppState, TeamActions>> => {
	const teamId = useTeamId();

	const previousTeamId = usePrevious<string | null>(teamId);
	if (teamId === null) {
		return stateSlice;
	}
	if ((!stateSlice[0].hasLoaded && !stateSlice[0].isLoading) || teamId !== previousTeamId) {
		stateSlice[1].collectTeamData(teamId);
	}
	return stateSlice;
};
